module.exports = __webpack_public_path__ + "img/VectorTick.8ba302eb.svg";